// removed by extract-text-webpack-plugin
module.exports = {"pagination":"_3MEvjCgYgP-MHTOPKBqfMI","text-center":"_37BnuPLMS_56QfWINO49Bo"};


//////////////////
// WEBPACK FOOTER
// ./components/ScheduledNotification/style.less
// module id = 1224
// module chunks = 0